import { io, Socket } from 'socket.io-client';
import { Region } from '@bringg/frontend-utils/dist/common/types';

export enum RealTimeEvents {
	ACTIVITY_CHANGE = 'activity change',
	WAY_POINT_ARRIVED = 'way point arrived',
	WAY_POINT_DONE = 'way point done',
	WAY_POINT_ETA_UPDATE = 'way point eta updated',
	WAY_POINT_LOCATION_UPDATE = 'way point location updated',
	ORDER_DONE = 'order done',
	ORDER_CANCELED = 'order cancelled',
	LOCATION_UPDATE = 'location update',
	WATCH_ORDER = 'watch order',
	WATCH_DRIVER = 'watch driver',
	WATCH_WAY_POINT = 'watch way point',
	CONNECT = 'connect'
}

export default class RealTimeService {
	_socket: Socket;
	_options: Partial<Region>;

	constructor(options: Partial<Region>) {
		this._options = options;
	}

	init() {
		if (this._socket) {
			this._socket.disconnect();
		}

		this._socket = io(this._options.real_time_url, {
			transports: ['websocket'],
			transportOptions: {
				websocket: {
					port: this._options.socket_websocket_port,
					secure: this._options.secured_sockets
				}
			}
		});
	}

	send(eventName: string, ...args: any[]) {
		this._socket.emit(eventName, ...args);
	}

	listen(eventName: string, fn: Function) {
		//@ts-ignore Type of evnet listener is more complex in socket, and it's complex to-reuse this type here
		this._socket.on(eventName, fn);
	}

	removeEvent(eventName: string, eventFunction?: (...args: any[]) => void) {
		this._socket.off(eventName, eventFunction);
	}

	removeAllEvents() {
		// @ts-ignore This method exist on component-emitter the types are incorrect
		this._socket.removeAllListeners();
	}
}
